import { createFileRoute } from '@tanstack/react-router'
import { Prose } from '@/components/Prose'

export const Route = createFileRoute('/_layout/contact')({
  component: ContactPage,
})

function ContactPage() {
  return (
    <section className="mx-auto max-w-3xl px-4 py-16">
      <Prose>
        <h1 className="text-text-primary">Contact Lunara</h1>
        <p>
          We read every message. For feedback, feature requests, press, or privacy inquiries, email
          us at <a href="mailto:hello@lunara.app">hello@lunara.app</a>.
        </p>

        <h2 className="text-text-primary">Privacy &amp; data requests</h2>
        <p>
          Because Lunara stores your cycle data on your device by default, there is usually no
          server-side data to delete — clearing your browser storage or using the tracker&apos;s
          &ldquo;erase everything&rdquo; action removes it completely. If you have an account and
          used encrypted sync, we can delete the associated ciphertext on request; we cannot read
          it, but we can remove it.
        </p>

        <h2 className="text-text-primary">Security reports</h2>
        <p>
          Found a security issue? Please email{' '}
          <a href="mailto:security@lunara.app">security@lunara.app</a> with details. We appreciate
          responsible disclosure.
        </p>
      </Prose>
    </section>
  )
}
